<template>
  <div class="head">
    <div class="tabList">
      <img
        class="logoImage"
        src="@/assets/images/logo.png"
        alt=""
        @click="routerPush('/')"
      />
      <div
        class="tabBox"
        :class="store.state.language == 'en' ? 'tabBoxEn' : ''"
        v-if="!store.state.isPc"
      >
        <div
          v-for="item in tabList"
          v-bind:key="item.routerName"
          :class="tabClickName == item.routerName ? 'handFont' : 'freeFont'"
          @click="routerPush(item.routerName)"
        >
          {{ store.state.language == "cn" ? item.title : item.titleEn }}
        </div>
      </div>

      <div
        class="tabBox Pc"
        :class="store.state.language == 'en' ? 'tabBoxEn' : ''"
        v-if="store.state.isPc"
      >
        <div
          v-for="item in tabList"
          v-bind:key="item.routerName"
          :class="tabClickName == item.routerName ? 'handFont' : 'freeFont'"
          @click="routerPush(item.routerName)"
        >
          {{ store.state.language == "cn" ? item.title : item.titleEn }}
        </div>
      </div>
    </div>
    <div class="languageBox">
      <div
        :class="store.state.language == 'cn' ? 'Btn' : 'disBtn'"
        @click="ChangeLanguage('cn')"
      >
        中
      </div>
      <div
        :class="store.state.language != 'cn' ? 'Btn' : 'disBtn'"
        @click="ChangeLanguage('en')"
      >
        Eng
      </div>
    </div>
  </div>
</template>

<script setup>
import { useStore } from "vuex";
import { ref, watch } from "vue";
import { useRouter, useRoute } from "vue-router";
const store = useStore();
const tabClickName = ref("/");
const router = useRouter();
const route = useRoute();
const tabList = ref([
  {
    routerName: "/",
    title: "产品",
    titleEn: "PRODUCT",
  },
  {
    routerName: "/Download",
    title: "软件",
    titleEn: "SOFTWARE",
  },
  {
    routerName: "/We",
    title: "我们",
    titleEn: "US",
  },
]);

const ChangeLanguage = (string) => {
  store.commit("changeLanguage", string);
};

const routerPush = (string) => {
  router.push(string);
};

watch(route, () => {
  tabClickName.value = route.meta.tabName;
});
</script>

<style lang="scss" scoped>
.head {
  width: 100%;
  height: 5.25rem;
  position: relative;
  max-width: 75rem;
  margin: 0 auto;
  min-width: 37.5rem;

  .tabList {
    display: flex;
    // justify-content: space-between;

    .logoImage {
      width: 5.625rem;
      height: 3.375rem;
      margin-top: 1.625rem;
      margin-left: 1.75rem;
    }
    .tabBox {
      width: 29.9375rem;
      // height: 50px;
      display: flex;
      margin-top: 1.8125rem;
      // margin-left: 213px;
      justify-content: space-between;
      padding-left: 5.9375rem;
      box-sizing: border-box;
      align-items: center;

      .handFont {
        font-size: 2.25rem;
        color: #ffffff;
        color: red;
        letter-spacing: 0;
        height: auto;
        text-align: center;
        text-shadow: 0.25rem 0.25rem 0.625rem rgba(0, 0, 0, 0.5);
        font-weight: 400;
        cursor: pointer;
      }

      .freeFont {
        font-size: 1.875rem;
        color: #ffffff;
        color: red;
        letter-spacing: 0;
        text-align: center;
        font-weight: 400;
        cursor: pointer;
      }
    }

    .Pc {
      .handFont {
        font-size: 1.375rem;
        color: #ffffff;
        color: red;
        letter-spacing: 0;
        height: auto;
        text-align: center;
        text-shadow: 0.25rem 0.25rem 0.625rem rgba(0, 0, 0, 0.5);
        font-weight: 400;
        cursor: pointer;
      }

      .freeFont {
        font-size: 1.125rem;
        color: #ffffff;
        color: red;
        letter-spacing: 0;
        text-align: center;
        font-weight: 400;
        cursor: pointer;
      }
    }

    .tabBoxEn {
      width: 32.4375rem;
      padding-left: 2.5rem;
      padding-right: 1.875rem;
    }
  }

  .languageBox {
    width: 5.0625rem;
    display: flex;
    justify-content: space-between;
    position: absolute;
    top: 2.5rem;
    right: 1.75rem;

    div {
      border-radius: 50%;
      width: 1.875rem;
      height: 1.875rem;
      line-height: 1.875rem;
      cursor: pointer;
    }

    .Btn {
      border: 0.0625rem solid rgba(255, 0, 13, 1);
      color: #ff000d;
      font-size: 0.875rem;
      letter-spacing: 0;
      font-weight: 400;
      text-align: center;
    }

    .disBtn {
      font-size: 0.75rem;
      color: rgba(255, 255, 255, 0.5);
      letter-spacing: 0;
      font-weight: 400;
      text-align: center;
      border: 0.0625rem solid rgba(255, 255, 255, 0.5);
      text-align: center;
    }
  }
}
</style>
